import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Agencies } from 'app/models/agencies';
import { Observable, Subject, throwError } from 'rxjs';
import { retry, catchError, tap } from 'rxjs/operators';
import { AdminsService } from '../admins/admins.service';

@Injectable({
  providedIn: 'root'
})
export class AdsService {

  base_path = 'https://app.titv-store-api.com/';
  constructor(private http: HttpClient,
    private authService:AdminsService) { }
    private refreshData = new Subject<void>();
    get refreshNedeed() {
      return this.refreshData;
    }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

  // Create a new item
  createAds(item): Observable<Agencies> {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return <Observable<Agencies>>this.http
      .post<Agencies>(this.base_path + 'agencies/signupagency', JSON.stringify(item),this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );
  }

  // Get single Agencies data by ID
  getAds(id): Observable<Agencies> {
    return <Observable<Agencies>>this.http
      .get(this.base_path + 'agencies' + '/' + id)
      
  }

  // Get Agenciess data
  getListAds(): Observable<Agencies> {
    return <Observable<Agencies>>this.http
      .get<Agencies>(this.base_path + 'agencies/all')
      
  }
 
  // Update item by id
  updateAds(id, item): Observable<Agencies> {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return <Observable<Agencies>>this.http
      .put<Agencies>(this.base_path + 'agencies/edit' + '/' + id, JSON.stringify(item),this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );
  }

  // Delete item by id
  deleteAds(id) {
    // let headers=new HttpHeaders({'Authorization':'Bearer '+sessionStorage.TOKEN_KEY});
    return this.http
      .delete<Agencies>(this.base_path + 'agencies/delete' + '/' + id,this.httpOptions)
      .pipe(
        tap(() => {
          this.refreshNedeed.next();
        })
      );
  }

 
}
